import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from "react-datepicker";
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { fullMonth } from 'utils/FormatDate';

const DataCardHeader = ({
    addButton,
    addAction,
    keyword,
    handleSearch,
    handleChangeKeyword
}) => {
    return (
        <Card.Header className="border-bottom border-200">
            <Row className="align-items-end g-2">
                <Col xs={3}>
                    <Form className="position-relative" onSubmit={handleSearch}>
                        <Row>
                            <Col md={8}>
                                <Form.Control
                                    type="  "
                                    placeholder="Search..."
                                    size="sm"
                                    aria-label="Search"
                                    name="q"
                                    className="rounded search-input ps-4"
                                    value={keyword}
                                    onChange={(event) => handleChangeKeyword(event)}
                                />
                                <FontAwesomeIcon
                                    icon="search"
                                    className="fs--1 text-400 position-absolute text-400 start-0 top-50 translate-middle-y ms-2"
                                />
                            </Col>
                            <Col md={4} className="d-grid gap-2">
                                <Button variant="falcon-default" size="sm" type="submit">
                                    Cari
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xs={{span:2, offset:7}} className="d-grid gap-2">
                    {
                        addButton && (
                            <Button variant="falcon-default" size="sm" onClick={addAction}>
                                <FontAwesomeIcon icon="plus" className="me-1" /> Tambah
                            </Button>
                        )
                    }
                </Col>
            </Row>
        </Card.Header>
    );
}

const DataCardHeaderParking = ({
    dataList,
    keyword,
    handleSearch,
    handleChangeKeyword,
    handleChangeDate,
    exportExcel,
    handleClickExport
}) => {
    return (
        <Card.Header className="border-bottom border-200">
            <Row className="align-items-end g-2">
                <Col xs={12}>
                    <Form className="position-relative" onSubmit={handleSearch}>
                        <Row>
                            <Col md={2}>
                                <Form.Select
                                    size="sm"
                                    aria-label="Search"
                                    name="report_type"
                                    className="rounded search-input ps-4"
                                    value={keyword.report_type}
                                    onChange={(event) => handleChangeKeyword(event)}
                                >
                                    <option value={1}>Tanggal</option>
                                    <option value={2}>Bulan</option>
                                    <option value={3}>Tahun</option>
                                </Form.Select>
                            </Col>
                            <Col md={2} className={classNames({'d-none': (parseFloat(keyword.report_type) !== 2)})}>
                                <Form.Select
                                    size="sm"
                                    aria-label="Search"
                                    name="month"
                                    className="rounded search-input ps-4"
                                    value={keyword.month}
                                    onChange={(event) => handleChangeKeyword(event)}
                                >
                                    <option value={1}>Januari</option>
                                    <option value={2}>Februari</option>
                                    <option value={3}>Maret</option>
                                    <option value={4}>April</option>
                                    <option value={5}>Mei</option>
                                    <option value={6}>Juni</option>
                                    <option value={7}>Juli</option>
                                    <option value={8}>Agustus</option>
                                    <option value={9}>September</option>
                                    <option value={10}>Oktober</option>
                                    <option value={11}>November</option>
                                    <option value={12}>Desember</option>
                                </Form.Select>
                            </Col>
                            <Col md={1} className={classNames({'d-none': (parseFloat(keyword.report_type) !== 3)})}>
                                <Form.Control
                                    type="text"
                                    placeholder="Tahun"
                                    size="sm"
                                    aria-label="Search"
                                    name="year"
                                    className="rounded search-input"
                                    value={keyword.year}
                                    onChange={(event) => handleChangeKeyword(event)}
                                />
                            </Col>
                            <Col md={2} className={classNames({'d-none': (parseFloat(keyword.report_type) !== 1)})}>
                                <DatePicker
                                    selected={new Date(keyword.fromDate)}
                                    onChange={(date)=>handleChangeDate(date, 'fromDate')}
                                    // formatWeekDay={day => day.slice(0, 3)}
                                    dateFormat="dd-MM-yyyy"
                                    className='form-control form-control-sm'
                                    placeholderText="Select Date"
                                />
                            </Col>
                            <Col md={2} className={classNames({'d-none': (parseFloat(keyword.report_type) !== 1)})}>
                                <DatePicker
                                    selected={new Date(keyword.toDate)}
                                    onChange={(date)=>handleChangeDate(date, 'toDate')}
                                    // formatWeekDay={day => day.slice(0, 3)}
                                    dateFormat="dd-MM-yyyy"
                                    className='form-control form-control-sm'
                                    placeholderText="Select Date"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Select
                                    placeholder="Search..."
                                    size="sm"
                                    aria-label="Search"
                                    name="parking_location"
                                    className="rounded search-input ps-4"
                                    value={keyword.parking_location}
                                    onChange={(event) => handleChangeKeyword(event)}
                                >
                                    <option value={0}>Semua Lokasi</option>
                                    {
                                        dataList.parking_location ? dataList.parking_location.map((val, idx) => {
                                            return (<option key={idx} value={val.value}>{val.label}</option>)
                                        }) : ''
                                    }
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Select
                                    placeholder="Search..."
                                    size="sm"
                                    aria-label="Search"
                                    name="vehicle_type"
                                    className="rounded search-input ps-4"
                                    value={keyword.vehicle_type}
                                    onChange={(event) => handleChangeKeyword(event)}
                                >
                                    <option value={0}>Semua Jenis Kendaraan</option>
                                    {
                                        dataList.vehicle_type ? dataList.vehicle_type.map((val, idx) => {
                                            return (<option key={idx} value={val.value}>{val.label}</option>)
                                        }) : ''
                                    }
                                </Form.Select>
                            </Col>
                            <Col md={1} className="d-grid gap-2">
                                <Button variant="falcon-default" size="sm" type="submit">
                                    Cari
                                </Button>
                            </Col>
                            <Col md={1} className={`d-grid gap-2 ${exportExcel ? '' : 'd-none'}`}>
                                <Button variant="success" size="sm" type="button" onClick={handleClickExport}>
                                    <FontAwesomeIcon icon={faFileExcel} />
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Card.Header>
    );
}

const DataCardHeaderReport = ({
    keyword,
    keywordShow,
    handleSearch,
    handleChangeKeyword,
    handleChangeDate,
    exportExcel,
    handleClickExport
}) => {
    return (
        <Card.Header className="border-bottom border-200">
            <Row className="align-items-end g-2">
                <Col xs={12}>
                    <Form className="position-relative" onSubmit={handleSearch}>
                        <Row>
                            <Col md={2}>
                                <Form.Control
                                    type="  "
                                    placeholder="Search..."
                                    
                                    aria-label="Search"
                                    name="q"
                                    className="rounded search-input ps-4"
                                    value={keyword.q}
                                    onChange={(event) => handleChangeKeyword(event, 'keyword')}
                                />
                                <FontAwesomeIcon
                                    icon="search"
                                    className="fs--1 text-400 position-absolute text-400 start-0 top-50 translate-middle-y ms-2"
                                />
                            </Col>
                            <Col md={2} className={keywordShow.reportTime ? '' : 'd-none'}>
                                <Form.Select
                                    name="reportTime"
                                    value={keyword.reportTime}
                                    onChange={(event) => handleChangeKeyword(event, 'keyword')}
                                >
                                    <option value={1}>Harian</option>
                                    <option value={2}>Mingguan</option>
                                    <option value={3}>Bulanan</option>
                                </Form.Select>
                            </Col>
                            <Col md={2} className={keywordShow.reportMonth ? '' : 'd-none'}>
                                <Form.Select
                                    name="reportMonth"
                                    value={keyword.reportMonth}
                                    onChange={(event) => handleChangeKeyword(event, 'keyword')}
                                >
                                    {
                                        fullMonth.map((val, idx) => {
                                            return (<option value={idx + 1} key={idx}>{val}</option>)
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            <Col md={2} className={keywordShow.reportYear ? '' : 'd-none'}>
                                <Form.Control
                                    type="text"
                                    value={keyword.reportYear}
                                    onChange={(event) => handleChangeKeyword(event, 'keyword')}
                                    name="reportYear"
                                />
                            </Col>
                            <Col md={2} className={keywordShow.fromDate ? '' : 'd-none'}>
                                <DatePicker
                                    selected={new Date(keyword.fromDate)}
                                    onChange={(date)=>handleChangeDate(date, 'fromDate')}
                                    // formatWeekDay={day => day.slice(0, 3)}
                                    dateFormat="dd-MM-yyyy"
                                    className='form-control'
                                    placeholderText="Select Date"
                                />
                            </Col>
                            <Col md={2} className={keywordShow.toDate ? '' : 'd-none'}>
                                <DatePicker
                                    selected={new Date(keyword.toDate)}
                                    onChange={(date)=>handleChangeDate(date, 'toDate')}
                                    // formatWeekDay={day => day.slice(0, 3)}
                                    dateFormat="dd-MM-yyyy"
                                    className='form-control'
                                    placeholderText="Select Date"
                                />
                            </Col>
                            <Col md={1} className="d-grid gap-2">
                                <Button variant="falcon-default" size="sm" type="submit">
                                    Cari
                                </Button>
                            </Col>
                            <Col md={1} className={`d-grid gap-2 ${exportExcel ? '' : 'd-none'}`}>
                                <Button variant="success" size="sm" type="button" onClick={handleClickExport}>
                                    <FontAwesomeIcon icon={faFileExcel} />
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Card.Header>
    );
}

const DataCardBody = ({
    children
}) => {
    return (
        <Card.Body >
            {children}
        </Card.Body>
    );
}

const DataCard = ({
    children
  }) => {
    return (
        <Card className="h-md-100">
            {children}
        </Card>
    );
}

DataCard.Header = DataCardHeader;
DataCard.HeaderParking = DataCardHeaderParking;
DataCard.HeaderReport = DataCardHeaderReport;
DataCard.Body = DataCardBody;

DataCard.propTypes = {};
DataCardHeader.propTypes = {
    addButton: PropTypes.bool
};

export default DataCard;